import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSite } from "../lib/site";
import { useT } from "../lib/i18n";

const ORIGIN = "https://apnsolarpartners.com";

export function Seo({ title, description, noindex, crumbs = [], jsonLd = [] }) {
  const { pathname } = useLocation();
  const site = useSite();
  const { lang, t: tk } = useT();
  const o = (lang === "en" && site.seo_overrides?.[pathname]) || {};
  const t = o.title || title;
  const d = o.description || description;
  const canonical = ORIGIN + (pathname === "/" ? "/" : pathname.replace(/\/+$/, ""));
  const fullTitle = pathname === "/" ? t : `${t} | ${site.brand_name}`;
  const ld = [
    { "@context": "https://schema.org", "@type": "WebSite", name: site.brand_name, url: ORIGIN },
    crumbs.length > 0 && {
      "@context": "https://schema.org", "@type": "BreadcrumbList",
      itemListElement: [{ name: tk("common.home"), to: "/" }, ...crumbs].map((c, i) => ({ "@type": "ListItem", position: i + 1, name: i === 0 ? c.name : tk(`paths.${c.to}`, null, c.name), item: ORIGIN + c.to })),
    },
    site.operator?.legal_name && {
      "@context": "https://schema.org", "@type": "Organization", name: site.operator.public_name || site.operator.legal_name, url: ORIGIN,
      contactPoint: { "@type": "ContactPoint", contactType: "customer service", telephone: site.operator.phone || undefined, email: site.operator.email || undefined, ...(site.operator.contact_person && { name: site.operator.contact_person }), availableLanguage: ["en", "hi"] },
      email: site.operator.email || undefined,
      telephone: [site.operator.phone, site.operator.phone2].filter(Boolean),
      ...(site.operator.office_address && { address: { "@type": "PostalAddress", streetAddress: site.operator.office_address, addressLocality: "Kota", addressRegion: "Rajasthan", postalCode: "324005", addressCountry: "IN" } }),
      ...(site.operator.gstin && { taxID: site.operator.gstin }),
    },
    ...jsonLd,
  ].filter(Boolean);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {d && <meta name="description" content={d} />}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex || o.robots === "noindex" ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      {d && <meta property="og:description" content={d} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === "hi" ? "hi_IN" : "en_IN"} />
      <meta property="og:locale:alternate" content={lang === "hi" ? "en_IN" : "hi_IN"} />
      <meta name="twitter:card" content="summary" />
      {site.gsc_verification && <meta name="google-site-verification" content={site.gsc_verification} />}
      {ld.map((x, i) => <script key={i} type="application/ld+json">{JSON.stringify(x)}</script>)}
    </Helmet>
  );
}
